import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { jsx } from '@emotion/react';
import { Box } from '../Box/Box.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const StyledTabPanel = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  target: "ezt2u2y0"
} : {
  target: "ezt2u2y0",
  label: "StyledTabPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "36s67d",
  styles: "&[aria-hidden=\"true\"]{display:none;}"
} : {
  name: "36s67d",
  styles: "&[aria-hidden=\"true\"]{display:none;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYlBhbmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPdUIiLCJmaWxlIjoiVGFiUGFuZWwudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIENvbXBvbmVudFByb3BzV2l0aFJlZiB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgdGhlbWVkLCBTdHlsZVByb3BzIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuXG5pbXBvcnQgeyBCb3ggfSBmcm9tIFwiLi4vQm94XCI7XG5cbmV4cG9ydCB0eXBlIFRhYlBhbmVsUHJvcHMgPSBTdHlsZVByb3BzICYgQ29tcG9uZW50UHJvcHNXaXRoUmVmPFwiZGl2XCI+O1xuXG5jb25zdCBTdHlsZWRUYWJQYW5lbCA9IHRoZW1lZChcImRpdlwiKTxTdHlsZVByb3BzPih7XG4gICcmW2FyaWEtaGlkZGVuPVwidHJ1ZVwiXSc6IHtcbiAgICBkaXNwbGF5OiBcIm5vbmVcIlxuICB9XG59KTtcblxuZXhwb3J0IGNvbnN0IFRhYlBhbmVsID0gZm9yd2FyZFJlZjxIVE1MRGl2RWxlbWVudCwgVGFiUGFuZWxQcm9wcz4oXG4gICh7IGNoaWxkcmVuLCAuLi5wcm9wcyB9LCByZWYpID0+IHtcbiAgICByZXR1cm4gKFxuICAgICAgPFN0eWxlZFRhYlBhbmVsIHJlZj17cmVmfSByb2xlPVwidGFicGFuZWxcIiB7Li4ucHJvcHN9PlxuICAgICAgICB7LyogV3JhcHBlciBuZWNlc3NhcnkgZm9yIFRhbGtCYWNrIChJRkwtMTYxNykgKi99XG4gICAgICAgIDxCb3g+e2NoaWxkcmVufTwvQm94PlxuICAgICAgPC9TdHlsZWRUYWJQYW5lbD5cbiAgICApO1xuICB9XG4pO1xuXG5UYWJQYW5lbC5kaXNwbGF5TmFtZSA9IFwiVGFiUGFuZWxcIjtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const TabPanel = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  return jsx(StyledTabPanel, _extends({
    ref: ref,
    role: "tabpanel"
  }, props), jsx(Box, null, children));
});
TabPanel.displayName = "TabPanel";

export { TabPanel };
